import React    from 'react';
import { Container,
         Card, 
         Row,
         Col  } from 'react-bootstrap';

function LoggedOutCard() {    
    return(<Container>
             <Row><Col>&nbsp;</Col></Row>
             <Row><Col></Col><Col>
             <Card>
               <Card.Header className="card-goal-header">
                 <Card.Title>Logged Out
                 </Card.Title>
               </Card.Header>
               <Card.Body>You need to log in to access this page.</Card.Body>
             </Card>
             </Col><Col></Col></Row>
           </Container>);
}

export default LoggedOutCard;
